import {
  DOMAIN_REGEX,
  HOSTNAME,
  LOCAL_HOST_FRAGMENT,
  STAGING_USER_HOST,
  TRUSTED_DOMAINS,
  USER_DOMAIN,
  USER_SUBDOMAIN,
} from '@/const'
import { store, isAdminStorage } from '@/store'
import { Modal } from '@seiue/ui'
import { useOnMount } from '@seiue/util'
import { schoolApi } from 'packages/sdks-next/growp'
import { getUrlParams } from 'packages/utils'
import React from 'react'

import { AdminHome } from './AdminHome'
import { UserHome } from './UserHome'

/**
 * App
 *
 * @returns app
 */
export const App: React.FC = () => {
  const isAdmin = store.get(isAdminStorage)
  const rootSchoolId = getUrlParams('_school_id', location.search)
  const _refreshProxyToken = getUrlParams(
    '_refresh_proxy_token',
    location.search
  )
  const isLocal = location.host.includes(LOCAL_HOST_FRAGMENT)
  const isStaging = location.host.includes(STAGING_USER_HOST)
  const reg = DOMAIN_REGEX
  const schoolUrl = location.hostname.match(reg)?.[1] || ''

  useOnMount(() => {
    if (
      schoolUrl === USER_SUBDOMAIN ||
      !location.hostname.endsWith('net') ||
      (!!rootSchoolId && !!_refreshProxyToken) ||
      !isAdmin
    ) {
      return
    }

    schoolApi.checkSchool(schoolUrl).then((res) => {
      const { data: school } = res
      if (!school?.id) {
        Modal.warning({
          title: '学校不存在',
          content: `不存在域名为 ${schoolUrl}.${HOSTNAME} 的学校，请重新输入网址。`,
        })
      } else {
        location.href = `https://${USER_DOMAIN}/interim/${school.id}`
      }
    })
  })

  if (!TRUSTED_DOMAINS.includes(schoolUrl) && !isLocal && !isStaging)
    return null
  return isAdmin ? <AdminHome /> : <UserHome />
}
